import { lazy, Suspense, useEffect, useState } from "react";
import { VideoProps } from "./type";

const Video = lazy(() => import("./Video"));

export function LazyVideo({
  videoUrl,
  play,
  styles,
  className,
  borderRadius,
  fullScreenControl = true,
  theme,
  storeMetadata,
  onChangePlaying,
}: VideoProps) {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return (
    <>
      {hasMounted && (
        <Suspense fallback={""}>
          <Video
            videoUrl={videoUrl}
            play={play}
            styles={styles}
            className={className}
            borderRadius={borderRadius}
            fullScreenControl={fullScreenControl}
            theme={theme}
            storeMetadata={storeMetadata}
            onChangePlaying={onChangePlaying}
          />
        </Suspense>
      )}
    </>
  );
}
